module.exports = __webpack_public_path__ + "static/media/64_.535a1168.png";